<template>
    <div class="contain">
        <div class="section-1">
            <div class="content-1">
                <div class="title-area" v-intersect>
                    <img class="imgs title" src="../../../assets/c28/img-title.png" alt="" ref="secondImage" >
                    <img class="imgs present" src="../../../assets/c28/img-present.png" alt="" >
                </div>
                <div class="cont-area">
                </div>                
                <img class="imgs banner" src="../../../assets/c28/img-banner.png" alt="">
            </div>    
            <a @click="selfDeepLink" style="cursor: pointer;" :class="['c28-floot-cta', { scrolled: isScrolled }]">
             검사 신청하러 가기
            </a>
        </div>
        <div class="section-2">
            <div class="content-1">
                <div class="title-area" v-intersect>
                    <span class="sub-title">국내 최초 • 국내 단독 출시</span>
                    <strong class="main-title">병원 전용 유전자<br>암검사를 집에서</strong>
                    <img class="imgs img-box-title" src="../../../assets/c30/img-box-title.png" alt="">
                </div>
                <div class="cont-area" v-intersect>
                    <img class="imgs" src="../../../assets/c28/img-cancer.png" alt="">
                </div>
            </div>
            <div class="content-2">
                <div class="title-area" v-intersect>
                    <strong class="main-title type3">이런 고민<br>해본 적 있나요?</strong>
                </div>
                <div class="cont-area" v-intersect>
                    <img class="imgs" src="../../../assets/c28/img-talk.png" alt="">
                </div>
            </div>
            <div class="content-2-1">
                <div class="title-area" v-intersect>
                    <strong class="main-title type3">대학병원에서 받는<br>암 유전자 검사,<br>솔닥에서는 <span class="text-orange">반값</span></strong>
                </div>
                <div class="cont-area" v-intersect>
                    <img class="imgs" src="../../../assets/c28/img-half-2.png" alt="">
                </div>
            </div>
            <div class="content-2-2">
                <div class="title-area" v-intersect>
                    <strong class="main-title type3">정확도 100%<br>믿을 수 있는 유전자 검사</strong>
                </div>
                <div class="cont-area" v-intersect>
                    <img class="imgs" src="../../../assets/c28/img-exact.png" alt="">
                </div>
            </div>
            <div class="content-3">
                <div class="title-area" v-intersect>
                    <strong class="main-title type3">국민 21명 중 1명은<br>암 유병자입니다</strong>
                    <span class="sub-title type2">출처 : 보건복지부(2024)</span>
                </div>
                <div class="cont-area" v-intersect>
                    <img class="imgs" src="../../../assets/c28/img-people.png" alt="">
                </div>
            </div>
            <div class="content-4">
                <div class="title-area" v-intersect>
                    <span class="sub-title type3">모두에게 찾아올 수 있는 암</span>
                    <strong class="main-title type3">유전자에서<br>힌트를 발견하세요</strong>
                </div>
                <div class="cont-area" v-intersect>
                    <img class="imgs" src="../../../assets/c28/img-hint.png" alt="">
                </div>
            </div> 
            <div class="content-5">
                <div class="title-area" v-intersect> 
                    <strong class="main-title type2">내가 특별히<br>조심해야 하는 암은?</strong>
                    <span class="sub-title type4">주요 5대 암부터 희귀암까지, <br> 나의 유전적 위험도를 파악하세요</span>
                </div>
                <div class="cont-area" v-intersect>
                    <img class="imgs" src="../../../assets/c28/img-careful.png" alt="">
                </div>
            </div>     
            <div class="content-6">
                <div class="title-area" v-intersect>
                    <strong class="main-title type2">몇 살 때 발병 위험이<br>가장 높아질까?</strong>
                    <span class="sub-title type4">연령대별 예상 유병률로 <br> 각별히 주의해야 하는 시기를 확인하세요</span>
                </div>
                <div class="cont-area" v-intersect>
                    <img class="imgs" src="../../../assets/c28/img-chart.png" alt="">
                </div>
            </div>             
        </div>
        <div class="section-3">
            <div class="content-1">
                <div class="title-area" v-intersect>
                    <strong class="main-title type2">발병 위험 높은 암<br>어떻게 대비해야 할까?</strong>
                    <span class="sub-title type4">암 예방을 위한 생활습관부터<br> 추천 검진 항목까지, 폭 넓게 살펴보세요</span>                    
                </div>
                <div class="cont-area" v-intersect>
                    <ul class="box-list">
                        <li class="box">
                            <strong class="box-title">예방을 위한 생활습관</strong>
                            <p>절주, 금연, 규칙적인 운동, 건강한 체중 유지</p>
                        </li>
                        <li class="box">
                            <strong class="box-title">증상</strong>
                            <p>배변 습관의 변화, 설사, 변비, 혈변 또는 끈적한 점액변, 배변 후 잔변감, 복통, 복부 팽만, 피로감, 식욕부진, 소화불량, 복부종괴(혹덩어리)</p>
                        </li>
                        <li class="box">
                            <strong class="box-title">검진 및 진단 방법</strong>
                            <ul>
                                <li><span>대상</span> <p>50세 이상</p></li>
                                <li><span>주기</span> <p>3~5년</p></li>
                                <li><span>방법</span> <p>분변잠혈 반응검사, (3~5년)대장내시경, 이상소견 또는 고위험군은 별도 관리</p></li>
                            </ul>
                        </li>
                        <li class="box">
                            <strong class="box-title">치료</strong>
                            <p>수술적 치료, 약물요법, 방사선치료</p>
                        </li>
                    </ul>                        
                </div>
            </div>
            <div class="content-2">
                <div class="title-area" v-intersect>
                    <strong class="main-title type2">병원 전용 유전자 검사<br>병원 가지 말고 이용하세요</strong>
                    <span class="sub-title type4">병원에서 받는 검사와 동일한 검사를<br>솔닥 비대면 진료로 집에서 편하게 누려보세요</span>                    
                </div>
                <img class="imgs" src="../../../assets/c28/img-nonface.jpg" alt="" v-intersect>
                <div class="cont-area" v-intersect>
                    <ul class="box-list">
                        <li class="box">
                            <div class="text-wrap">                            
                                <strong class="box-title">의료진 의뢰서 및 동의서 작성</strong>
                                <p class="sub-title type4">병원 방문 없이 비대면진료로 진행 가능</p>
                            </div>
                        </li>
                        <li class="box">
                            <div class="text-wrap"> 
                                <strong class="box-title">키트 수령 후 검체 채취</strong>
                            </div>
                        </li>
                        <li class="box">
                            <div class="text-wrap"> 
                                <strong class="box-title">검사 기관 발송 후 유전자 분석</strong>
                            </div>
                        </li>
                        <li class="box">
                            <div class="text-wrap">
                                <strong class="box-title">검사 결과 모바일 수령</strong>
                            </div>
                        </li>
                    </ul>
                    <div class="box info">
                        <p>의료진 비대면 동의서 작성 및 상담은 <strong>비대면진료 솔닥 앱</strong>에서 이용 가능합니다.</p>
                    </div>                        
                </div>
            </div>
            <div class="content-3">
                <div class="title-area" v-intersect>
                    <strong class="main-title type2">영상으로 쉽게 배우는<br>유전자 검체 채취 방법</strong>             
                </div>
                <div class="video-wrap">
                    <iframe id="ytplayer" class="video-yt" type="text/html" width="716" height="405" align=center
    src="https://www.youtube.com/embed/Vu0Ns4gC3YA?autoplay=1&mute=1&controls=0&loop=1&playlist=Vu0Ns4gC3YA&rel=0"
    frameborder="0" allowfullscreen noresize></iframe>
                </div>
                <div class="cont-area" v-intersect>
                    <img class="imgs" src="../../../assets/c28/img-step.png" alt=""/>
                </div>
            </div>               
        </div>
        <div class="section-4">
            <div class="content-1">
                <div class="title-area" v-intersect>
                    <span class="sub-title type1">부모님 효도 선물 강력 추천</span>                          
                    <strong class="main-title type2">프리미엄<br>유전자 암검사 BEST</strong>
                </div>
                <div class="cont-area" v-intersect>
                  <div class="box">
                    <div class="box-top">
                        <div class="ico-wrap">
                            <img src="../../../assets/c28/ico-cancer-22.png" alt="">
                        </div>
                        <div class="text-wrap">
                            <strong>암 22종</strong>
                            <span>암 22종 발병 위험도 검사</span>
                            <p>한국인 대표 5대암 + <br>
                            각 성별 특화 검사</p>
                        </div>
                    </div>
                    <div class="box-mid">
                        <span class="sub-text">정가 <span>400,000원</span></span>
                        <strong class="main-text"><span>-58%</span>170,000원</strong>
                    </div>
                    <div class="box-bot">
                        <button type="button" class="btn btn-popup-open" @click="showModal1 = true">자세히 보기</button>
                    </div>
                  </div> 
                </div>
            </div>
            <div class="content-2">
                <div class="title-area" v-intersect>
                    <span class="sub-title type1">나를 위한 가성비 갑 셀프 선물</span>     
                    <strong class="main-title type2">대표암 및<br>여성, 남성암 5종</strong>              
                </div>
                <div class="cont-area" v-intersect>
                    <div class="box type01">
                        <div class="box-left">
                            <div class="ico-wrap">
                                <img src="../../../assets/c28/ico-cancer-5.png" alt="">
                            </div>
                            <span class="sub-text">정가 <span>150,000원</span></span>
                            <strong class="main-text"><span>-47%</span>80,000원</strong>
                        </div>
                        <div class="box-right">
                            <div class="text-wrap">
                                <strong>대표암 5종</strong>
                                <p>한국인 유병률이 높은<br>
                                주요 암 5종 위험도 확인</p>
                            </div>
                            <button type="button" class="btn btn-popup-open" @click="showModal2 = true">자세히 보기</button>
                        </div>
                    </div>     
                    <div class="box-wrap">
                        <div class="box type02">
                            <div class="box-left">
                                 <div class="text-wrap">
                                    <strong>남성암 5종</strong>
                                </div>
                                <div class="ico-wrap">
                                    <img src="../../../assets/c28/ico-cancer-man.png" alt="">
                                </div>
                                <div class="text-wrap">
                                    <p>남성에게 발병할 수 있는<br>
                                    주요 암 5종 위험도 확인</p>
                                </div>                           
                                <span class="sub-text">정가 <span>150,000원</span></span>
                                <strong class="main-text"><span>-47%</span>80,000원</strong>
                                <button type="button" class="btn btn-popup-open" @click="showModal3 = true">자세히 보기</button>
                            </div>
                        </div>   
                        <div class="box type02">
                            <div class="box-left">
                                 <div class="text-wrap">
                                    <strong>여성암 5종</strong>
                                </div>
                                <div class="ico-wrap">
                                    <img src="../../../assets/c28/ico-cancer-woman.png" alt="">
                                </div>
                                <div class="text-wrap">
                                    <p>여성에게 발병할 수 있는<br>
                                    주요 암 5종 위험도 확인</p>
                                </div>                           
                                <span class="sub-text">정가 <span>150,000원</span></span>
                                <strong class="main-text"><span>-47%</span>80,000원</strong>
                                <button type="button" class="btn btn-popup-open" @click="showModal4 = true">자세히 보기</button>
                            </div>
                        </div>   
                    </div>              
                </div>
            </div>        
        </div>
        <div class="section-5">
            <div class="content-1">
                <div class="title-area" v-intersect>                       
                    <strong class="main-title type2">의료기관의 전문성과<br>비대면의 편리함을 한 번에</strong>
                </div>
                <div class="cont-area" v-intersect>
                    <img class="imgs" src="../../../assets/c28/img-cross.png" alt=""/>
                </div>
            </div>     
            <div class="content-2">
                <div class="title-area" v-intersect> 
                    <span class="sub-title type5">아시아 최초 유전자 분석 상용화 기업</span>                      
                    <strong class="main-title type2">테라젠헬스와 함께합니다</strong>
                    <p class="sub-title type4">테라젠헬스는 아시아 최초로 유전자 분석을 상용화하여, <br>
                    강북삼성병원, 세브란스병원, 국립암센터 등 <br>
                    650여 개의 연계 병원에 서비스를 제공해왔습니다.</p>
                </div>
                <div class="cont-area" v-intersect>
                    <img class="imgs" src="../../../assets/c28/img-dna.jpg" alt=""/>
                </div>
            </div>     
        </div>
        <div class="section-6">
            <div class="content-1">
                <div class="title-area" v-intersect>                     
                    <strong class="main-title">이런 분께 추천해요</strong>
                </div>
                <div class="cont-area" v-intersect>
                    <img class="imgs" src="../../../assets/c28/img-recommend.png" alt=""/>
                </div>
            </div> 
            <div class="content-2">
                <div class="title-area" v-intersect>                     
                    <p class="text-count">이 시간이 지나면 가격이<span>최대 58%</span>올라요</p>
                     <countdown-timer 
                        :start-date="new Date('2025-01-09 00:00:00')"
                        :end-date="new Date('2025-02-03 00:00:00')"
                    />
                </div>
                <div class="cont-area" v-intersect>
                    <img class="imgs" src="../../../assets/c28/img-timer.png" alt=""/>
                </div>
                <div class="box" v-intersect>
                    <p>기간 한정 새해 기념 할인 특별가로</p>
                    <div class="btn-wrap">
                        <a @click="selfDeepLink" style="cursor: pointer;">검사 신청하러 가기</a>
                    </div>
                </div>
            </div> 
        </div>
        <div class="section-7">
            <div class="faq faq-container">
              <div class="title-area">
                <h2 class="text-xl">자주 묻는 질문</h2>
              </div>
              <dl class="faq-list">
                <dt :class="{ 'opened': openIndex === 0 }">
                  <button type="button" @click="toggle(0)">
                    <span class="subject">서비스 이용 가능 연령 제한이 있나요? </span>
                  </button>
                </dt>
                <dd v-show="openIndex === 0">
                  <ul>
                    <li>
                     본 서비스는 별도의 연령 제한은 없으나 만 18세 미만 미성년자 또는 금치산자의 경우 법정대리인의 동의가 필요합니다.
                    </li>
                  </ul>
                </dd>
                <dt :class="{ 'opened': openIndex === 1 }">
                  <button type="button" @click="toggle(1)">
                    <span class="subject">개인정보 및 유전자 분석 결과가 노출될 위험은 없나요?</span>
                  </button>
                </dt>
                <dd v-show="openIndex === 1">
                  <ul>
                    <li>
                        본 서비스는 병원에서 익명화된 개인 정보를 수령하게 되므로 개인 정보 유출 위험이 없습니다. 유전자 분석 결과는 외부와 단절된 시스템을 통해서 보관되며, 보안 담당자만 열람 가능합니다.
                    </li>
                  </ul>
                </dd>
                <dt :class="{ 'opened': openIndex === 2 }">
                  <button type="button" @click="toggle(2)">
                    <span class="subject"
                      >가족단위 서비스를 받는 것이 좋은가요?</span
                    >
                  </button>
                </dt>
                <dd v-show="openIndex === 2">
                  <ul>
                    <li>
                     가족 전체가 개인 유전자 정보 서비스를 이용하신다면 가족간의 유전되는 질병 정보와 가족력을 알아볼 수 있습니다. 특히, 자녀는 부모의 유전자를 물려받기 때문에 건강, 질병, 신체적 특징과 관련된 유전 인자들을 이해하는 데 큰 도움이 될 것입니다.
                    </li>
                  </ul>
                </dd>
                <dt :class="{ 'opened': openIndex === 3 }">
                  <button type="button" @click="toggle(3)">
                    <span class="subject"
                      >이미 대장암에 걸렸었는데 위험 요인이 낮다고 나오는데, 어떻게 된 것인가요?</span
                    >
                  </button> 
                </dt>
                <dd v-show="openIndex === 3">
                  <ul>
                    <li>
                      암을 비롯한 많은 질환들은 유전적 요인과 환경적 요인이 복합적으로 작용합니다. 즉 타고난 유전적 질병 위험은 낮지만 술, 흡연 등의 환경 요인에 의해 질병이 생길 수 있습니다.
                    </li>
                  </ul>
                </dd>
                <dt :class="{ 'opened': openIndex === 4 }">
                  <button type="button" @click="toggle(4)">
                    <span class="subject"
                      >유전적 위험도와 가족력은 어떻게 다른 가요? 어떤 것을 더 신뢰할 수 있나요?</span
                    >
                  </button> 
                </dt>
                <dd v-show="openIndex === 4">
                  <ul>
                    <li>
                      가족력은 질병 예측에 있어 매우 중요한 정보이지만, 일부 질환은 가족력과는 무관한 경우도 있으며, 정확한 가족력을 알 수 없는 경우가 많습니다. 또한 유전적인 변이가 있더라도 부모세대에서는 나타나지 않은 질병이 자녀에게서 나타나기도 합니다. 따라서 가족력보다 실제 자신의 DNA에 있는 유전적인 변이를 직접 분석하는 것이 보다 정확하다고 할 수 있습니다.
                    </li>
                  </ul>
                </dd>
                <dt :class="{ 'opened': openIndex === 5 }">
                  <button type="button" @click="toggle(5)">
                    <span class="subject"
                      >이 서비스를 받기에 가장 좋은 연령대는 언제인가요?</span
                    >
                  </button> 
                </dt>
                <dd v-show="openIndex === 5">
                  <ul>
                    <li>
                      일반적인 검사는 나이가 많을수록 질병이 확인될 확률이 높아지지만 유전적인 소인은 나이와 관계없이 항상 똑같습니다. 그러나 나이가 어릴 때 검사를 하면 그만큼 대처할 수 있는 시간이 많아지는 것이므로 질병 예방에 도움이 됩니다. 보다 젊은 나이에 질병 예방을 위한 적극적인 운동, 식이 등 좋은 습관을 어릴 때부터 만들어 나갈 것을 권장하고 있습니다.
                    </li>
                  </ul>
                </dd>
                <dt :class="{ 'opened': openIndex === 6 }">
                  <button type="button" @click="toggle(6)">
                    <span class="subject"
                      >유전자 검사는 평생 한번만 하면 되는 것인가요?</span
                    >
                  </button> 
                </dt>
                <dd v-show="openIndex === 6">
                  <ul>
                    <li>
                      개인의 유전 정보는 나이에 따라 달라지지 않지만, 지속적으로 더 많은 연구가 보고되고 경험이 축적되면서 보다 더 정확한 질병 예측이 가능하기 때문에 추후 다시 받아 볼 것을 권장할 수 있습니다.
                    </li>
                  </ul>
                </dd>
              </dl>
            </div>
            <div class="policy-container">
                  <div class="policy-main-title">꼭 확인하세요!</div>
              
                  <div class="policy-list">
                    <div class="policy-list-item">유전자 검사 서비스 유효기간은 구매일로부터 3개월입니다.</div>
                    <div class="policy-list-item">유효기간 이후에는 서비스 제공 및 환불이 불가합니다.</div>
                    <div class="policy-list-item">상품 수령한 날로부터 7일이 경과한 경우, 고객님의 단순변심으로는 교환, 환불 불가합니다.</div>
                    <div class="policy-list-item">상품 택(tag) 제거 또는 개봉으로 상품 가치가 훼손된 경우
                      <div class="policy-sublist">
                        <div class="policy-sublist-item">상품 수령 후 7일 이내라도 교환, 환불 불가합니다.</div>
                      </div>
                    </div>
                    <div class="policy-list-item">타인의 검체로 검사를 진행할 경우, 검사 결과 미제공 및 교환, 환불 불가합니다.</div>
                  </div>
              
                  <div class="policy-section-title">[ 주의사항 ]</div>
                  <div class="policy-list">
                    <div class="policy-list-item">채취 후 빠르게 반송해주세요
                      <div class="policy-sublist">
                        <div class="policy-sublist-item">검사 결과의 신뢰도를 위해 채취 후 바로 반송 부탁드립니다.</div>
                        <div class="policy-sublist-item">1개월 이상 반송 지연 시, 검사 결과가 불확실해질 수 있으며, 재채취 비용 (10,000원)이 추가로 발생할 수 있습니다.</div>
                        <div class="policy-sublist-item">검사 받으실 분의 정보를 정확히 입력해주세요</div>
                        <div class="policy-sublist-item">유전자 검사는 신청하신 본인의 검체로만 진행 가능합니다.</div>
                        <div class="policy-sublist-item">타인의 검체로 검사를 진행할 경우, 검사 결과는 제공 되지 않으며, 교환 및 환불이 불가합니다.</div>
                      </div>
                    </div>
                  </div>
              
                  <div class="policy-section-title">[ 문의처 ]</div>
                  <div class="policy-list">
                    <div class="policy-list-item">솔닥 고객센터
                      <div class="policy-sublist">
                        <div class="policy-sublist-item">결제 및 배송지 변경 문의</div>
                        <div class="policy-sublist-item">전화: 02-6954-7676</div>
                      </div>
                    </div>
                    <div class="policy-list-item">테라젠 고객센터
                      <div class="policy-sublist">
                        <div class="policy-sublist-item">배송 진행 상황, 교환 및 반품, 재채취 관련 문의</div>
                        <div class="policy-sublist-item">전화: 1522-2375</div>
                      </div>
                    </div>
                  </div>
              
                  <div class="policy-main-title ver2">배송 안내</div>
                  <div class="policy-list">
                    <div class="policy-list-item">출고 기준 : 병원에서 접수된 정보가 테라젠으로 전달된 시간에 따라 출고 일정이 달라집니다 
                        <div class="policy-sublist">
                            <div class="policy-sublist-item">오전 12시 이전 접수: 당일 출고</div>
                            <div class="policy-sublist-item">오전 12시 이후 접수: 익일 출고</div> 
                        </div>
                    </div>
                    <div class="policy-list-item">출고 후 일반적으로 1~3일 내에 배송됩니다. (지역 및 택배사 사정에 따라 변동 가능)</div>
                    <div class="policy-list-item">배송 진행 상황은 솔닥 앱 또는 테라젠 고객센터(1522-2375)를 통해 확인하실 수 있습니다.</div>
                  </div>
              
                  <div class="policy-main-title ver3">교환 및 환불 안내</div>
                  <div class="policy-list">
                    <div class="policy-list-item">상품 수령일로부터 7일 이내 청약 철회 가능합니다.</div>
                  </div>
              
                  <div class="policy-section-title">[ 환불 기준 ]</div>
                  <div class="policy-list">
                    <div class="policy-list-item">상품 출고 전 (운송장 번호 생성 전)
                        <div class="policy-sublist">
                            <div class="policy-sublist-item">유전자검사 키트 상품 출고 전인 경우 100% 환불 가능합니다.</div>
                            <div class="policy-sublist-item">문의: 솔닥 고객센터 (02-6954-7676)</div>
                        </div>
                    </div>
                    <div class="policy-list-item">상품 출고 후 (배송 중 포함)
                        <div class="policy-sublist">
                            <div class="policy-sublist-item">상품 출고 후 교환/반품/환불 관련 문의는 테라젠헬스 고객센터 (1522-2375)로 문의주세요. 반품 진행은 검사기관인 테라젠헬스와 협의하신 후 상품을 반송해 주세요.</div>
                            <div class="policy-sublist-item">고객님의 단순 변심, 귀책 사유로 인해 교환 및 환불 시 발생하는 비용은 고객님께서 부담하셔야 합니다.</div>
                            <div class="policy-sublist-item">환불 진행은 내부 기준에 따라 키트 훼손 여부 확인 후 처리됩니다.
                                <div class="policy-sublist">
                                    <div class="policy-sublist-item">키트 구성품이 훼손된 경우 : 16,000원 발생 (키트 구성품 비용 + 왕복 택배비)</div>
                                    <div class="policy-sublist-item">키트 구성품이 미훼손된 경우 : 6,000원 발생 (왕복 택배비)</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="policy-list-item">실험 진행 중 (반송 접수 후, 전달 완료 시)
                        <div class="policy-sublist">
                            <div class="policy-sublist-item">환불 불가</div>
                        </div>                    
                    </div>
                  </div>
            </div>
        </div>


        <Modal 
          :isOpen="showModal1"
          @close="showModal1 = false"
          title="암 22종"
          :originalPrice="400000"
          :discountedPrice="170000"
        >
          <div class="main-space">
            <p class="info-title">대표암 5종 및 추가 17종 암에 대한 위험도 확인</p>
            <div class="box">
                <div>
                  <strong class="box-title">검사 항목</strong>
                  <p class="box-text">
                    위암, 대장암(직장암), 폐암, 간암, 췌장암,
                    담낭암, 신장암, 구강암, 후두암, 갑상선암,
                    피부암(악성 흑색종), 피부암(기저세포암),
                    피부암(편평상피세포암), 뇌종양(신경교종),
                    비호지킨림프종, 급성 골수성 백혈병, <br>
                    급성 림프구성 백혈병
                  </p>
                </div>

                <div>
                  <strong class="box-title">남성 추가 4종</strong>
                  <p class="box-text">방광암, 식도암, 전립선암, 고환암</p>
                </div>

                <div>
                  <strong class="box-title">여성 추가 4종</strong>
                  <p class="box-text">유방암, 난소암, 자궁경부암, 자궁내막암</p>
                </div>
            </div>
          </div>
        </Modal>
                <Modal 
          :isOpen="showModal2"
          @close="showModal2 = false"
          title="대표암 5종"
          :originalPrice="150000"
          :discountedPrice="80000"
        >
          <div class="main-space">
            <p class="info-title">한국인 유병율이 높은 주요 암 5종 위험도 확인</p>
            <div class="box type02">
                <div>
                  <strong class="box-title">검사 항목</strong>
                  <p class="box-text type02">
                   위암, 폐암, 간암, 대장암(직장암), 대장암(결장암)
                  </p>
                </div>
            </div>
          </div>
        </Modal>
                <Modal 
          :isOpen="showModal3"
          @close="showModal3 = false"
          title="남성암 5종"
          :originalPrice="150000"
          :discountedPrice="80000"
        >
          <div class="main-space">
            <p class="info-title">남성에게 발병할 수 있는 주요 암 5종 위험도 확인</p>
            <div class="box type02">
                <div>
                  <strong class="box-title">검사 항목</strong>
                  <p class="box-text type02">
                    위암, 폐암, 간암, 대장암(직장암), 전립선암
                  </p>
                </div>
            </div>
          </div>
        </Modal>
                <Modal 
          :isOpen="showModal4"
          @close="showModal4 = false"
          title="여성암 5종"
          :originalPrice="150000"
          :discountedPrice="80000"
        >
          <div class="main-space">
            <p class="info-title">여성에게 발병할 수 있는 주요 암 5종 위험도 확인</p>
            <div class="box type02">
                <div>
                  <strong class="box-title">검사 항목</strong>
                  <p class="box-text type02">
                    위암, 유방암, 간암, 대장암(직장암), 갑상선암
                  </p>
                </div>
            </div>
          </div>
        </Modal>

    </div>
</template>

<script>
import CountdownTimer from './../../common/CountdownTimer.vue'
import Modal from './../../common/Modal.vue'
export default {
    name: "c28",
     components: {
       CountdownTimer,
       Modal
    },
     directives: {
        intersect: {
            // 요소가 DOM에 삽입될 때 호출됩니다.
            inserted(el) {
                const options = {
                    root: null, // 뷰포트를 기본값으로 설정
                    rootMargin: '0px', // 뷰포트의 마진은 0
                    threshold: 0.1 // 10%가 보일 때 콜백이 실행
                };
                const callback = (entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            el.classList.add('visible');
                        } else {
                            el.classList.remove('visible');
                        }
                    });
                };
                const observer = new IntersectionObserver(callback, options);
                observer.observe(el); // 해당 요소를 관찰 시작
            }
        }
    },
    data() {
        return {
            isScrolled: false,
            openIndex: 0, // 초기에 아무 항목도 열려있지 않음
            showModal1: false,
            showModal2: false,
            showModal3: false,
            showModal4: false,
            abx_tid: null
        };
    },
    methods: {
        selfDeepLink() {

            if (!navigator.userAgent.match(/Android/i) && !navigator.userAgent.match(/iPhone|iPad/i)) {       
                window.location.href = 'https://event.soldoc.co.kr/';
                return;
            }

            if (!wcs_add) var wcs_add={};
                window.wcs_add = {wa:"s_4b46bc66587"}; //윈도우 객체 선언
                if (!_nasa) var _nasa={};
                if(window.wcs){
                    wcs.inflow();
                    wcs_do();
                }
            if(window.wcs){
                if(!wcs_add) var wcs_add = {};
                window.wcs_add = {wa:"s_4b46bc66587"}; //윈도우 객체 선언
                var _conv = {};
                    _conv.type = 'lead';    	
                wcs.trans(_conv);
            }


            // 앱의 스키마 URL
            var appSchemeURL = 'soldoc://home/search?departmentId=26?serviceType=CONTACTLESS?type=DEPARTMENT?after-login';
            // 안드로이드와 iOS 마켓 URL
            var androidMarketURL = 'https://play.google.com/store/apps/details?id=com.soldocapp';
            var iosMarketURL = 'https://apps.apple.com/kr/app/soldoc-%EB%B9%84%EB%8C%80%EB%A9%B4%EC%A7%84%EB%A3%8C-%EC%86%8C%EB%B9%84%EC%9E%90%EB%A7%8C%EC%A1%B1%EC%A7%80%EC%88%98-1%EC%9C%84/id1667730511';

            if(this.abx_tid !== undefined)
            {
                appSchemeURL = 'soldoc://home/search?departmentId=26?serviceType=CONTACTLESS?type=DEPARTMENT?after-login&abx_tid=' + this.abx_tid;
                androidMarketURL = 'https://play.google.com/store/apps/details?id=com.soldocapp&referrer=abx_tid%3D' + this.abx_tid;  // Google Play 스토어 링크
                iosMarketURL = 'https://apps.apple.com/kr/app/%EC%86%94%EB%8B%A5-%EB%B9%84%EB%8C%80%EB%A9%B4%EC%A7%84%EB%A3%8C-%EC%86%8C%EB%B9%84%EC%9E%90%EB%A7%8C%EC%A1%B1%EC%A7%80%EC%88%98-1%EC%9C%84/id1667730511?&referrer=abx_tid%3D' + this.abx_tid;  //appstore 스토어 링크
            }


            // 리다이렉트를 체크할 시간 간격
            var timeoutMs = 2000;

            // 앱 실행 시도
            window.location.href = appSchemeURL;

            // 2초 후에 페이지 가시성 체크
            setTimeout(function() {
                if (document.visibilityState === 'visible') {
                    // 사용자의 기기에 따라 적절한 마켓으로 리다이렉트
                    if (navigator.userAgent.match(/Android/i)) {
                        window.location.href = androidMarketURL;
                    } else if (navigator.userAgent.match(/iPhone|iPad/i)) {
                        window.location.href = iosMarketURL;
                    }
                    else 
                    {
                        window.location.href = 'https://event.soldoc.co.kr/';
                    }
                }
            }, timeoutMs);   
        },
        handleScroll() {
            const secondImage = this.$refs.secondImage;
            const rect = secondImage.getBoundingClientRect();
            this.isScrolled = rect.top <= window.innerHeight - 1600;
        },
        toggle(index) {
      // 이미 열려 있는 항목을 클릭하면 모두 닫힘
      this.openIndex = this.openIndex === index ? -1 : index;
    },
    },
    mounted() {
        function getAbxTidParameter() {
            var landingPageUrl = window.location.search.substring(1),
                referrerDatas = landingPageUrl.split('&'),
                referrerParamName,
                i;
        
            for (i = 0; i < referrerDatas.length; i++) {
                referrerParamName = referrerDatas[i].split('=');
        
                if (referrerParamName[0] === "abx_tid") {
                    return referrerParamName[1] === undefined ? true : referrerParamName[1];
                }
            }
        };
        this.abx_tid = getAbxTidParameter();
        window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
};
</script>

<style scoped>
    * {
        margin: 0;
        padding: 0;
    }
   
    .contain {
        width: 100%;
        max-width: 800px;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        margin: 0 auto;
        overflow: hidden;
    }
    @keyframes fadeInUp {
        from {opacity: 0; transform: translate3d(0, 40px, 0);}
        to {opacity: 1; transform: translate3d(0, 0, 0);}
    }
    .visible {
        animation: fadeInUp 1.2s ease forwards;
        transition-delay: 0.5s;
    }

    .section-1 .title-area, .section-2 .title-area, .section-2 .cont-area, .section-3 .title-area, .section-3 .cont-area, .section-3 .content-2 .imgs, .section-4 .title-area, .section-4 .cont-area, .section-5 .title-area, .section-5 .cont-area, .section-6 .title-area, .section-6 .cont-area, .section-6 .box {
        opacity: 0; 
        transform: translate3d(0, 40px, 0); 
        transition: opacity 0.5s ease-out, transform 0.5s ease-out;
    }

    .contain .imgs {
        width: 100%;
    }
    .contain .imgs.banner {
        margin-top: 78px;
    }
    .contain a:hover {
        text-decoration: none;
    }
    .contain li {
        list-style: none;
    }
    .contain .sr-only {
        position: absolute;
        left: -9999px;
        width: 1px;
        height: 1px;
        margin: 0 !important;
        font-size: 0;
        line-height: 0;
        overflow: hidden;
    }
     .c28-floot-cta {
        position: fixed;
        bottom: 35px;
        left: calc(50% - 355px);
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 712px;
        height: 90px;

        visibility: hidden;
        opacity: 0;
        transition: opacity 0.5s ease;
        z-index: 50;

        background-color: #1e4a96;
        border-radius: 11px;
        box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.1);
        color: #fff;
        font-weight: 600;
        font-size: 32px;
        line-height: 32px;
    }
    .c28-floot-cta.scrolled {
        visibility: visible;
        opacity: 1;
    }

    .title-area {
        text-align: center;
    }
    .main-title {
        display: block;
        color: #fff;
        font-weight: 600;
        font-size: 70px;
        line-height: 94px;
        letter-spacing: -0.02em;
    }
    .main-title.type2 {
        color: #333;
        font-size: 62px;
        line-height: 86px;
    }
    .sub-title {
        display: inline-block;
        color: #008def;
        font-size: 32px;
        font-weight: 600;
        line-height: 40px;
        letter-spacing: -0.02em;
        margin-bottom: 24px;
    }
    .sub-title.type2 {
        color: #ccc;
        font-size: 26px;
        font-weight: 400;
        line-height: 38px;
        margin-top: 32px;
        margin-bottom: 0;
    }
    .sub-title.type3 {
        color: #ccc;
        font-size: 28px;
        line-height: 40px;
        margin-bottom: 18px;
    }
    .sub-title.type4 {
        color: #777;
        font-size: 28px;
        line-height: 42px;
        font-weight: 400;
        margin-top: 32px;
        margin-bottom: 0;
    }
    .sub-title.type5{
        font-size: 28px;
        margin-bottom: 16px;
    }
    .section-1 {
        background-color: #4e3725;
        background-image: url(../../../assets/c28/bg-twinkle.png);
        background-repeat: no-repeat;
        background-size: 800px;
        background-position: 0px 15px;
    }
    .section-1 .title-area {
        margin-top: 125px;
    }
    .section-1 .imgs.title{
        width: 433px;
    }
    .section-1 .imgs.present{
        margin-top: 84px;
        width: 653px;
    }
    .section-2 {
        padding-top: 135px;
        background-color: #333;
    }
    .section-2 .main-title.type3 {
        font-size: 62px;
        line-height: 86px;
    }
    .section-2 .content-1 .cont-area {
        margin-top: 80px;
    }
    .section-2 .content-1 .title-area .img-box-title {
        width: 425px;
        margin-top: 28px;
    }
    .section-2 .content-2  {
        margin-top: 240px;
    }
    .section-2 .content-2 .cont-area {
       display: flex;
       justify-content: center;
       margin-top: 104px;
    }
    .section-2 .content-2 .imgs {
        width: 716px;
    }
    .section-2 .content-2-1  {
        margin-top: 240px;
    }
    .section-2 .content-2-1 .cont-area {
       display: flex;
       justify-content: start;
       margin-top: 76px;
    }
    .section-2 .content-2-1 .imgs {
        width: 757px;
    }   
    .section-2 .content-2-1 .text-orange {
        position: relative;
        color: #EF7F3A;
    }
    .section-2 .content-2-1 .text-orange:after {
        content: '';
        display: inline-block;
        position: absolute;
        bottom: -4px;
        left: -20px;
        width: 171px;
        height: 27px;
        background: url(../../../assets/c28/bg-pen.png) no-repeat center/cover;
    }
    .section-2 .content-2-2  {
        margin-top: 240px;
    }
    .section-2 .content-2-2 .cont-area {
       display: flex;
       justify-content: center;
       margin-top: 81px;
    }
    .section-2 .content-2-2 .imgs {
        width: 716px;
    }   
    .section-2 .content-3  {
        margin-top: 212px;
    }
    .section-2 .content-3 .cont-area {
        display: flex;
        justify-content: center;
        margin-top: 29px;
    }
    .section-2 .content-3 .imgs {
        width: 719px;
    }
    .section-2 .content-4  {
        margin-top: 265px;
        padding-bottom: 194px;
    }
    .section-2 .content-4 .cont-area {
        display: flex;
        justify-content: center;
        margin-top: 78px;
    }
    .section-2 .content-4 .imgs {
        width: 539px;
    }
    .section-2 .content-5  {
        padding-top: 146px;
        padding-bottom: 174px;
        background-color: #e5f0fc;
    }
    .section-2 .content-5 .cont-area {
        display: flex;
        justify-content: center;
        margin-top: 59px;
    }
    .section-2 .content-5 .imgs {
        width: 722px;
    }
    .section-2 .content-6  {
        padding-top: 170px;
        background-color: #ffffff;
    }
    .section-2 .content-6 .cont-area {
        display: flex;
        justify-content: center;
        margin-top: 59px;
    }
    .section-2 .content-6 .imgs {
        margin-top: 20px;
        width: 716px;
    }

    .section-3 {
        padding-top: 228px;
    }
    .section-3 .box-list {
        margin: 100px auto 0;
        width: 716px;
    }
    .section-3 .box-list .box {
        width: 100%;
        padding: 40px;
        padding-bottom: 50px;
        background-color: #f7f7f7;
        border-radius: 18px;
        padding-right: 60px;

    }
    .section-3 .box-list .box + .box {
        margin-top: 10px;
    }
    .section-3 .box-list p {
        margin-top: 10px;
        padding-left: 74.5px;
    }
    .section-3 .box-list .box li {
        position: relative;
        margin: 10px 16.5px 10px 6.5px;
        padding-bottom: 10px;
    }
    .section-3 .box-list .box li:last-child {
        padding-bottom: 0;
        margin-bottom: 0;
    }
    .section-3 .box-list li span {
        position: absolute;
        top: 3px;
        left: 0px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 83px;
        height: 36px;

        background-color: #e5f0fc;
        color: #008def;
        border-radius: 18px;
        font-weight: 400;
        font-size: 26px;
        line-height: 42px;
        letter-spacing: -0.02em;
    }
    .section-3 .box-list .box li p {
        padding-left: 105.5px;
    }
    .section-3 .box-list p, .section-3 .box-list li {
        font-size: 28px;
        font-weight: 400;
        line-height: 42px;
        letter-spacing: -0.02em;
        color: #777;
    }
    .section-3 .box-title {
        display: flex;
        align-items: center;
        font-size: 34px;
        font-weight: 600;
        line-height: 50px;
        letter-spacing: -0.02em;
        color: #333;
        padding-bottom: 3px;
    }
    .section-3 .content-1 .box-title::before {
        content: '';
        display: inline-block;
        width: 54px;
        height: 50px;
        margin-right: 20px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
    }
    .section-3 .content-1 .box:nth-child(1) .box-title::before { background-image: url(../../../assets/c28/ico-health.png); }
    .section-3 .content-1 .box:nth-child(2) .box-title::before { background-image: url(../../../assets/c28/ico-heart.png); }
    .section-3 .content-1 .box:nth-child(3) .box-title::before { background-image: url(../../../assets/c28/ico-doctor.png); }
    .section-3 .content-1 .box:nth-child(4) .box-title::before { background-image: url(../../../assets/c28/ico-protect.png); }

    .section-3 .content-2 {
        margin-top: 207px;
    }
    .section-3 .content-2 .imgs {
        margin-top: 97px;
    }
    .section-3 .content-2 .box-list {
        width: 100%;
    }
    .section-3 .content-2 .box {
        display: flex;
        align-items: center;
        justify-content: start;
        gap: 48px;
        padding: 0 0 0 77px;
        background-color: #fff;
    }
    .section-3 .content-2 .box.info {
        margin: 85px auto 0;
        width: 715px;
        padding: 34px 34px 39px 34px;
        background-color: #f7f7f7;
        border-radius: 20px;
    }
    .section-3 .content-2 .box + .box{
        margin-top: 54px;
    }
    .section-3 .content-2 .box p {
        margin-top: 14px;
        padding-left: 0;
    }
    .section-3 .content-2 .box.info p {
        position: relative;
        margin-top: 0px;
        font-size: 28px;
        font-weight: 400;
        line-height: 42px;
        letter-spacing: -0.02em;
        color: #777;
        padding-left: 54px;
    }
    .section-3 .content-2 .box.info p span {
        font-weight: 600;
    }
    .section-3 .content-2 .box.info p::before {
        position: absolute;
        left: 0;
        top: 3px;
        content: '';
        display: inline-block;
        width: 32px;
        height: 32px;
        background: url(../../../assets/c28/ico-info.png) no-repeat center/cover;
    }
    .section-3 .content-2 .box::before {
        flex: 0 0 auto;
        content: '';
        display: inline-block;
        width: 140px;
        height: 140px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
    }
    .section-3 .content-2 .box.info::before {
        display: none;
    }
    .section-3 .content-2 .box:nth-child(1)::before { background-image: url(../../../assets/c28/ico-write.png); }
    .section-3 .content-2 .box:nth-child(2)::before { background-image: url(../../../assets/c28/ico-mouth.png); }
    .section-3 .content-2 .box:nth-child(3)::before { background-image: url(../../../assets/c28/ico-dna.png); }
    .section-3 .content-2 .box:nth-child(4)::before { background-image: url(../../../assets/c28/ico-mobile.png); }

    .section-3 .content-3 {
        margin-top: 210px;
        padding-bottom: 232px;
    }
    .section-3 .content-3 .video-wrap {
        margin: 87px 42px 0 42px;
        border-radius: 12px;
        overflow: hidden;
    }

    .section-3 .content-3 .imgs {
        width: 715px;
    }
    .section-3 .content-3 .cont-area {
        display: flex;
        justify-content: center;
        margin-top: 67px;
    }

    .section-4 {  
        width: 100%;
        padding-top: 156px;      
        padding-bottom: 163px;
        background-color: #E5F0FC;
    }
    .section-4 .main-title.type2 {
        color: #2C1808;
    }
    .section-4 .box {
        position: relative;
        margin: 0 auto;
        width: 711px;
        height: 546px;
        margin-top: 75px;
        border-radius: 20px;
        background-color: #fff;
    }
    .section-4 .content-1 .box::before {
        position: absolute;
        left: 0;
        top: 0;
        content: '';
        display: inline-block;
        width: 132px;
        height: 132px;
        background: url(../../../assets/c28/ico-best.png) no-repeat center/cover;
    }
    .section-4 .content-1 .box .box-top {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 47px;
        padding-top: 38px;
    }
    .section-4 .content-1 .box .ico-wrap img {
        width: 234px;
    }
    .section-4 .box .text-wrap {

    }
    .section-4 .box .text-wrap strong {
        display: block;
        font-weight: 600;
        font-size: 50px;
        line-height: 88px;
        letter-spacing: -0.02em;
        color: #000;
        text-align: center;
        margin-bottom: 4px;
    }
    .section-4 .box .text-wrap span {
        font-weight: 600;
        font-size: 32px;
        line-height: 42px;
        letter-spacing: -0.02em;
        color: #0789ff;
        text-align: center;
    }
    .section-4 .box .text-wrap p {
        font-weight: 400;
        font-size: 28px;
        line-height: 46px;
        letter-spacing: -0.02em;
        color: #434343;
        text-align: center;
        margin-top: 6px;
    }
    .section-4 .content-1 .box .box-mid {
        margin-top: 42px;
        display: flex; 
        align-items: center;
        justify-content: center;
        gap: 50px;
    }
    .section-4 .box .sub-text {
        font-weight: 400;
        font-size: 32px;
        line-height: 53px;
        letter-spacing: -0.02em;
        color: #999;
        text-align: center;
    }
    .section-4 .box .sub-text span{
        text-decoration: line-through;
    }
    .section-4 .box .main-text {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        font-weight: 600;
        font-size: 48px;
        line-height: 53px;
        letter-spacing: -0.02em;
        color: #333;
        text-align: center;
    }
    .section-4 .box .main-text span{
        display: inline-block;
        width: 100px;
        height: 49px;
        font-size: 35px;
        font-weight: 600;
        line-height: 48px;
        letter-spacing: -0.02em;
        text-align: center;
        color: #fff;
        background-color: #DA3C3E;
        border-radius: 6px;
    }
    .section-4 .content-1 .box-bot {
        margin-top: 56px;
        display: flex;
        justify-content: center;
    }
    .section-4 .btn-popup-open {
        width: calc(100% - 62px);
        padding: 19px 0;
        border-radius: 10px;
        background-color: #008def;
        color: #fff;
        text-align: center;
        font-weight: 400;
        font-size: 26px;
        line-height: 42px;
        letter-spacing: -0.02em;
    }
    .section-4 .content-2 {
        margin-top: 212px;
    }
    .section-4 .content-2 .cont-area{
        margin-top: 75px;
    }
    .section-4 .content-2 .box.type01 {
        display: flex;
        align-items: start;
        gap: 72px;
        width: 711px;
        height: 382px;
        padding: 24px 34px 35px 50px;
    }
    .section-4 .content-2 .box-left {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 18px;
    }
    .section-4 .content-2 .box-left .ico-wrap img {
        width: 160px;
        height: 150px;
    }
    .section-4 .content-2 .box-left .sub-text {
        font-size: 26px;
        line-height: 42px;
        margin-top: 45px;
    }
    .section-4 .content-2 .box-left .main-text {
        font-size: 38px;
        line-height: 42px;
        margin-top: 11px;
    }
    .section-4 .content-2 .box-left .main-text span {
        width: 80px;
        height: 39px;
        font-size: 28px;
        line-height: 39px;
    }
    .section-4 .content-2 .box .text-wrap strong {
        font-size: 42px;
    }
    .section-4 .content-2 .box .text-wrap p {
        line-height: 42px;
    }
    .section-4 .content-2 .btn-popup-open {
        width: 311px;
    }
    .section-4 .content-2 .box.type01 .btn-popup-open {
        margin-top: 65px;
    }

    .section-4 .content-2 .box-wrap {
        padding: 0 42px;
    }
    .section-4 .content-2 .box.type02 {
        display: inline-block;
        width: 348px;
        height: 664px;
        margin-top: 30px;
    }
    .section-4 .content-2 .box.type02 .ico-wrap img{
        margin-top: 20px;
        width: 98px;
        height: 94px;
    }
    .section-4 .content-2 .box.type02 + .box.type02{
        margin-left: 15px;
    }
    .section-4 .content-2 .box.type02 + .box.type02 .ico-wrap img{
        margin-top: 0;
        width: 123.5px;
        height: 123.5px;
    }
     .section-4 .content-2 .box.type02 .text-wrap p{
        margin-top: 52px;
    }
     .section-4 .content-2 .box.type02 + .box .text-wrap p{
        margin-top: 42px;
    }
     .section-4 .content-2 .box.type02 .sub-text{
        margin-top: 32px;
    }
    .section-4 .content-2 .box.type02 .box-left {
        padding: 28px 18px 22px 18px;
    }
    .section-4 .content-2 .box.type02 .box-left .main-text{
        margin-top: 16px;
    }
    .section-4 .content-2 .box.type02 .btn-popup-open {
        margin-top: 58px;
    }

    .section-5 {
        padding-top: 219px;
        width: 100%;
        background: url(../../../assets/c28/bg-wave.png) no-repeat center 74px /800px;
    }
    .section-5 .content-1 .cont-area {
        margin-top: 68px;
    }
    .section-5 .content-1 .cont-area .imgs {
        width: 716px;
        margin: 0 42px;
    }
    .section-5 .content-2 {
        margin-top: 217px;
    }
    .section-5 .sub-title.type4 {
        margin-top: 36px;
    }
    .section-5 .content-2 .imgs{
        margin-top: 85px;
    }

    .section-6 {
        width: 100%;
        padding-top: 207px;
        padding-bottom: 283px;
        background-color: #333;
    }
    .section-6 .main-title {
        font-size: 62px;
    }
    .section-6 .content-1 .imgs {
        width: 716px;
        margin: 65px 42px 0;
    }
    .section-6 .content-2 {
        margin-top: 286px;
    }
    .section-6 .content-2 .imgs {
        margin: 71px 175px 0 204px;
        width: 421px;
    }
    .section-6 .content-2 .text-count {
        font-size: 34px;
        line-height: 88px;
        font-weight: 600;
        letter-spacing: -0.02em;
        color: #fff;
    }
    .section-6 .content-2 .text-count span {
        margin : 0 4px;
        padding: 0 2px;
        width: 139px;
        height: 42px;
        border-radius: 6px;
        background-color: #da3c3e;
    }
    .section-6 .content-2 .box {
        width: 716px;
        height: 263px;
        margin: 134px 42px 0;
        padding: 22px 0 0 0;
        background-color: #fff;
        border-radius: 20px;
        text-align: center;
    }
    .section-6 .content-2 .box p {
        position: relative;
        display: inline-block;
        padding-left: 45px;
        font-size: 34px;
        line-height: 88px;
        font-weight: 600;
        letter-spacing: -0.02em;
        color: #333;
    }
    .section-6 .content-2 .box p::before {
        position: absolute;
        left: 0;
        top: calc(50% - 18px);
        content: '';
        display: inline-block;
        width: 36px;
        height: 36px;
        background: url(../../../assets/c28/ico-info.png) no-repeat center/cover
    }
    .section-6 .content-2 .box a {
        display: inline-block;
        width: 680px;
        height: 116px;
        margin-top: 16px;
        line-height: 116px;
        border-radius: 20px;
        color: #fff;
        font-weight: 600;
        font-size: 34px;
        letter-spacing: -0.02em;
        background-color: #008def;
    }

    .section-7 {
        padding-top: 159px;
    }
    .section-7 .text-xl {
        font-weight: 600;
        font-size: 62px;
        line-height: 86px;
        letter-spacing: -0.02em;
        color: #333;
    }
    .section-7 .content-1 {
        margin-top: 179px;
        margin-bottom: 104px;
    }

    .faq button {
        border: none;
    }
    .faq.faq-container {
      max-width: 715px;
      width: 715px;
      margin: 0 auto;
    }
    .faq .title {
      text-align: center;
        /* opacity: 0; 
        transform: translate3d(0, 40px, 0); 
        transition: opacity 0.5s ease-out, transform 0.5s ease-out; */
    }
    .faq .faq-list {
      margin-top: 90px;
      margin-bottom: 0;
      border-bottom: 1.5px solid #ccc;
        /* opacity: 0; 
        transform: translate3d(0, 40px, 0); 
        transition: opacity 0.5s ease-out, transform 0.5s ease-out; */
    }
    .faq .faq-list a {
      text-decoration: underline;
      text-underline-offset: 3px;
    }
    .faq .faq-list dt {
      position: relative;
    }
    .faq .faq-list dt .subject {
      padding-left: 35px;
      padding-right: 70px;
      text-align: left;
      font-weight: 400;
      font-size: 26px;
      line-height: 40px;
      letter-spacing: -0.02em;
      color: #333;
    }
    .faq .faq-list dt .subject::before {
      position: absolute;
      left: 0; 
      top: 10px;
      content: "Q";
      display: inline-block;
      width: 15px;
      font-size: 26px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 54px;
      color: #1E4A96;
      margin-right: 24px;
    }
    .faq .faq-list dt:not(.opened) button::after {
      background-image: url(../../../assets/c28/ico-faq-open.png);
    }
    .faq .faq-list dt:not(.opened) + dd {
      max-height: 0;
    }
    .faq .faq-list dt button {
      display: flex;
      gap: 20px;
      width: 100%;
      padding: 16px 0px;
      border-top: 1.5px solid #ccc;
      font-size: 20px;
      font-weight: 600;
      line-height: 40px;
      background-color: #fff;
    }
    .faq .faq-list dt button::after {
      content: "";
      position: absolute;
      right: 0px;
      top: calc(50% - 20px);
      width: 38px;
      height: 40px;
      background-image: url(../../../assets/c28/ico-faq-close.png);
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }
    .faq .faq-list dd {

      word-break: break-all;
      word-wrap: break-word;
      overflow: hidden;
      transition: max-height 0.3s ease-in-out;
    }
    .faq .faq-list dd > ul {
      border-top: 1.5px solid #ccc;
      margin-bottom: 15px;
      padding: 25px 0px;
      border-radius: 0px;
      background: #F9FAFB;
      margin-bottom: 0;
    }
    .faq .faq-list dd li {
      position: relative;
      padding-left: 33px;
      padding-right: 20px;
      font-size: 26px;
      line-height: 42px;
      font-weight: 400;
      letter-spacing: -0.02em;
      color: #555;
    }
    .faq .faq-list dd li::before {
      position: absolute;
      left: 0;
      top: -6px;
      content: "A";
      display: inline-block;
      width: 15px;
      font-size: 26px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 54px;
      color: #1E4A96;
      margin-right: 18px;
    }

    .accordion-enter-active,
    .accordion-leave-active {
      will-change: height, opacity;
      transition: height 0.8s ease, opacity 0.8s ease;
      overflow: hidden;
    }

    .accordion-enter,
    .accordion-leave-to {
      height: 0 !important;
      opacity: 0;
    }

 .policy-container {
    margin: 179px auto 104px;
    width: 100%;
    letter-spacing: -0.02em;
    padding: 97px 42px 222px 42px;
    background-color: #f6f6f6;
  }

 .policy-main-title {
    font-size: 42px;
    line-height: 88px;
    font-weight: 600;
    margin-bottom: 19px;
    color: #333;
  }

 .policy-main-title.ver2 {
    margin-top: 38px;
  }

 .policy-main-title.ver3 {
    margin-top: 41px;
  }

  .policy-section-title {
    font-size: 24px;
    font-weight: 600;
    line-height: 40px;
    /* margin-top: 22px; */
    color: #000;
  }
  

  .policy-list-item {
    font-size: 24px;
    position: relative;
    line-height: 40px;
    padding-left: 39px;
    margin: 0px 0;
    color: #000;
  }

  .policy-list-item::before {
    content: "•";
    position: absolute;
    left: 15px;
  }

  .policy-sublist {
    margin-left: 24px;
  }

  .policy-sublist-item {
    position: relative;
    padding-left: 10px;
    margin: 0px 0;
  }

  .policy-sublist-item::before {
    content: "•";
    position: absolute;
    left: -12px;
  }

</style>



// WEBPACK FOOTER //
// src/components/pc_view/contents/c28.vue